import React from 'react';
import { GlobalStyles, styled } from '@mui/material';
import { BottomDialog, IBottomDialogProps } from 'lib/BottomDialog';

const globalStyles = (
    <GlobalStyles
        styles={{
            '.global-blur': {
                filter: 'blur(1px)',
                opacity: 0.75
            }
        }}
    />
);

const StyledBottomDialog = styled(BottomDialog)({
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
});

export const PayBaseModal: React.FC<React.PropsWithChildren<IBottomDialogProps>> = props => {
    React.useEffect(() => {
        const removeBlur = () => {
            const doc = document.getElementById('root');
            if (doc) {
                doc.classList.remove('global-blur');
            }
        };
        if (props.open) {
            const doc = document.getElementById('root');
            if (doc) {
                doc.classList.add('global-blur');
            }
        } else {
            removeBlur();
        }
        return () => removeBlur();
    }, [props.open]);

    return (
        <>
            {globalStyles}
            <StyledBottomDialog {...props} />
        </>
    );
};
